// Accordion logic for footer menus
// Place in assets/footer-accordion.js

document.addEventListener("DOMContentLoaded", function () {
	var accordions = document.querySelectorAll(".fara-footer-accordion-toggle");
	accordions.forEach(function (toggle) {
		var caret = toggle.querySelector(".fara-footer-caret");
		toggle.addEventListener("click", function () {
			var section = toggle.parentElement;
			var links = section.querySelector(".fara-footer-links");
			var expanded = toggle.getAttribute("aria-expanded") === "true";
			toggle.setAttribute("aria-expanded", !expanded);
			links.classList.toggle("fara-footer-links-active");
		});
		toggle.addEventListener("keydown", function (e) {
			if (e.key === "Enter" || e.key === " ") {
				e.preventDefault();
				toggle.click();
			}
		});
	});
});
